<template>
  <w-icon-wrapper
    icon-name='work-repair-icon'
    :height='23.492'
    :width='23.49'
    view-box='0 0 23.49 23.492'
  >
    <g
      id="_112_Reparatur"
      data-name="112_Reparatur"
      transform="translate(-1827.53 -928)"
    >
      <path
        id="Pfad_15"
        data-name="Pfad 15"
        d="M78.6,18.22l-7.33-7.34-1.11,1.11-.86-.86,3.71-3.72a3.951,3.951,0,0,0,5.62-4.99L75.98,5.07,73.94,3.03,76.59.38a3.973,3.973,0,0,0-4.37.84,3.9,3.9,0,0,0-.98,3.9,3.673,3.673,0,0,0,.37.87l-4.34,4.34-1.41,1.42-4.34,4.33a3.623,3.623,0,0,0-1.09-.42,3.931,3.931,0,0,0-4.51,5.41l2.64-2.64,2.04,2.03-2.65,2.65a3.954,3.954,0,0,0,4.99-5.62l3.7-3.71.86.86-1.1,1.1,7.34,7.34a1.431,1.431,0,0,0,2.01,0l2.85-2.85a1.412,1.412,0,0,0,0-2.01m-3.86,3.04-5.51-5.52,2.04-2.03,5.51,5.51Z"
        transform="translate(1772 928)"
        fill="currentColor"
      />
      <path
        id="Pfad_16"
        data-name="Pfad 16"
        d="M60.44,3.5l.17-.17L57.82,0,55.53,2.29,58.84,5.1l.19-.18,6.07,6.07,1.41-1.42Z"
        transform="translate(1772 928)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconRepair' };
</script>
